import React, { Component } from 'react'
// @ts-ignore
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import GlobalInputs from './styles'
import { LabelWrap } from '../TextInput/styles'
import { Label } from '../Label'

interface SearchProps {
  onChange?: (name: string, value: string) => void
  value?: string
  placeholder?: string
  name?: string
  label?: string
}
//
// interface SearchState {
//   isOpen: boolean
//   search: string
// }
class PhoneSelector extends Component<SearchProps> {
  onChange = (value: string) => {
    const { onChange, name } = this.props
    if (onChange) {
      onChange(name ? name : 'mobileNumber', value)
    }
  }
  render() {
    const { value, label } = this.props

    return (
      <>
        <LabelWrap>
          {!!label && (
            <div>
              <Label>{label}</Label>
            </div>
          )}
        </LabelWrap>
        {/*<PhoneInput*/}
        {/*  placeholder={placeholder}*/}
        {/*  value={value}*/}
        {/*  onChange={this.onChange}*/}
        {/*  defaultCountry="US"*/}
        {/*/>*/}
        <PhoneInput
          country={'us'}
          value={value}
          onChange={this.onChange}
        />
        <GlobalInputs />
      </>
    )
  }
}

export default PhoneSelector
